import { Box } from "@mantine/core";

import { FLAG_PRIORITY_CHIP_TOKENS, FlagPriority } from "../constants/flags";
import { PRIORITY_DOT_SIZE } from "../constants/ui";

/** A flag with no priority gets the same neutral dot as one that left the library. */
const UNRANKED_DOT_COLOR = "gray.5";

interface FlagPriorityDotProps {
  priority: FlagPriority | null;
  /**
   * The flag's library entry was deleted. Its priority still orders it among the others, but the
   * dot turns neutral, so the colour doesn't claim a tier the label no longer shows.
   */
  isDeprecated?: boolean;
}

/**
 * The coloured dot that stands for a flag's priority.
 *
 * Every surface that shows a flag draws the same one — the info box row, the drawer card, the client
 * list popover, and the priority badge itself — so the hue a tier reads as is decided in one place.
 */
export default function FlagPriorityDot({ priority, isDeprecated = false }: FlagPriorityDotProps) {
  const tier = isDeprecated ? null : priority;

  return (
    <Box
      w={PRIORITY_DOT_SIZE}
      h={PRIORITY_DOT_SIZE}
      style={{ borderRadius: "50%", flexShrink: 0 }}
      bg={tier ? FLAG_PRIORITY_CHIP_TOKENS[tier].dot : UNRANKED_DOT_COLOR}
    />
  );
}
